import styled from 'styled-components';
import { space } from 'styled-system';

import { colors, transition } from 'theme';

const Textarea = styled.textarea<{ hasError: boolean }>`
  margin: 0;
  padding: 1em;
  font: inherit;
  width: 100%;
  color: ${colors.charcoalGrey};
  background-color: ${colors.white};
  border: solid 1px;
  border-color: ${colors.silver};
  border-radius: 4px;
  transition: all ${transition};
  ${(props) =>
    props.hasError &&
    `
    border-color: ${colors.scarlet};
    box-shadow: 0 0 0 1px ${colors.scarlet};
  `}
  &:focus {
    border-color: ${colors.waterBlue};
    box-shadow: 0 0 0 1px ${colors.waterBlue};
    outline: 0;
  }
  ::placeholder {
    color: ${colors.middleGrey};
  }
  ${space};
`;
// eslint-disable-next-line import/no-default-export
export default Textarea;
